<div class="onboarding">
  <div class="onboarding-title" [innerHTML]="'CHATBOT.ONBOARDING.HEADER' | transloco">
  </div>

  <div class="onboarding-categories" @listAnimation>
    @if (categories) {
      @if (selectedCategory$ | async; as selectedCategory) {
        <div class="onboarding-categories__item"
             [class.selected]="true">
          {{ selectedCategory.name }}
          <mat-icon [svgIcon]="'heroicons_outline:x'"
                    class="min-w-4 min-h-4 w-4 h-4"
                    (click)="selectCategory(0)"/>
        </div>
      }
      @if (selectedSubCategory$ | async; as selectedSubCategory) {
        <div class="onboarding-categories__subitem"
             [class.selected]="true">
          {{ selectedSubCategory.name }}
          <mat-icon [svgIcon]="'heroicons_outline:x'"
                    class="min-w-4 min-h-4 w-4 h-4"
                    (click)="selectSubCategory(0)"/>
        </div>
      }

      @for (category of categories; track category.chatCategoryId) {
        @if (!(selectedCategoryId$ | async)) {
          <div class="onboarding-categories__item"
               @itemAnimation
               (click)="selectCategory(category.chatCategoryId)">
            {{ category.name }}
          </div>
        }

        @if (category.chatCategoryId === (selectedCategoryId$ | async) && !(selectedSubCategory$ | async)) {
          @for (subCat of category.subCategories; track subCat.chatSubCategoryId) {
            <div class="onboarding-categories__subitem"
                 @itemAnimation
                 (click)="selectSubCategory(subCat.chatSubCategoryId)">
              {{ subCat.name }}
            </div>
          }
        }

      }
    }
  </div>

  @if (isCategorySet$ | async) {
    <div class="onboarding-title mt-4" [innerHTML]="'CHATBOT.ONBOARDING.FOOTER' | transloco">
    </div>
  }
</div>
